import React, { Component, Fragment } from "react";
import "./login.css";
import mainUserworkspace from "../../assets/images/general/havayar_logo_type_slogan.svg";
import { Tab, Tabs } from "react-bootstrap";
import LoginByMobile from "./loginByMobile";
import SignUp from "./signUp";
import ForgetPassword from "./forgetPassword";
import { ToastContainer } from "react-toastify";

export default class login extends Component {
    render() {
        return (
            <Fragment>
                <ToastContainer />
                <main className="loginsview"></main>
                <div className="login_logo container">
                    <div className="row">
                        <a href="/" className="col text-center">
                            <img src={mainUserworkspace} alt="" />
                        </a>
                    </div>
                </div>
                <div className="login_container container">
                    <Tabs
                        className="nav justify-content-center mb-4"
                        className="logintabs"
                        defaultActiveKey="serial"
                        id="uncontrolled-tab-example"
                    >
                        <Tab eventKey="serial" title="ورود" tabClassName="nav-item">
                            <LoginByMobile />
                        </Tab>
                        <Tab eventKey="signup" title="ثبت نام" tabClassName="nav-item">
                            <SignUp />
                        </Tab>
                        <Tab eventKey="forgetPass" title="فراموشی رمز" tabClassName="nav-item">
                            <ForgetPassword />
                        </Tab>
                    </Tabs>
                </div>
            </Fragment>
        );
    }
}
